<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-main class="flex-column">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div class="font-18-30313a font-bold">客户回访</div>
          <div class="line"></div>
          <div>
            <div><span>客户信息：</span>{{info.name}}</div>
            <div><span>装修地址：</span>{{info.detailedAddress}}</div>
          </div>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7 h-0">
        <div class="addBtn cursor mb-10" @click="addReturn"  v-if="permission.indexOf('customerReturnBasic') !== -1">
          <img src="/static/images/customer/chubeikehu.png" alt="">
          <div>新增回访</div>
        </div>
        <div class="flex-1 mb-10 returnList h-0">
          <el-scrollbar style="height: 100%;">
            <div class="returnItem" v-for="(item, index) in handleList" :key="index">
              <div class="flex top align-center">
                <div class="flex-1" :style="{'border-right': permission.indexOf('customerReturnBasic') !== -1 ? '1px solid #e2e2e2' : ''}">
                  <div class="p-10">
                    <div class="font-14-30313a font-bold mb-2">{{item.foundName}} - 回访</div>
                    <div class="font-12-b9b9b9 mb-5">{{Utils.formatTime2(item.createTime)}}</div>
                    <div class="font-12-85 mb-8" v-if="item.handlerList.length > 0"><span class="font-12-ff5555">待处理人：</span>{{executorList(item.handlerList)}}</div>
                    <div class="flex">
                      <span class="font-12-b9b9b9 mn-10">回访内容：</span>
                      <div class="flex-1">
                        <div class="font-12-30313a">{{item.content}}</div>
                        <div class="flex flex-wrap" v-if="item.photoList.length > 0">
                          <div v-for="(pic, j) in item.photoList" :key="j" class="mr-10 mb-10">
                            <viewer :images="item.photoList">
                              <img style="width: 90px; height: 90px" :src="Utils.IMG_PREV + pic.path" fit="cover">
                            </viewer>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex w-260 p-10 justify-end" v-if="permission.indexOf('customerReturnBasic') !== -1">
                  <button class="btn-16-bd-85 mr-5" @click="toChangeHandler(item)">换处理人</button>
                  <button class="btn-16-bg-ff5555 mr-5" @click="toHandle(item)" v-if="item.canHandle">处理结果</button>
                  <button class="btn-16-bg-85 mr-5" @click="toReturn(item)" v-if="!item.delete && item.canHandle">回访结果</button>
                  <button class="btn-16-bd-ff5555" @click="toDelete(item)" v-if="item.delete">删除</button>
                </div>
              </div>
              <div v-if="item.resultList.length > 0">
                <transition name="expand">
                  <div class="center" v-show="item.active">
                    <div class="list">
                      <div v-for="(result, i) in item.resultList" :key="i">
                        <div>
                          <div class="font-14-30313a font-bold mb-2">{{result.handlerName}}-{{result.type === 1 ? '处理结果' : '回访结果'}}：</div>
                          <div class="font-12-b9b9b9 mb-5">{{Utils.formatTime2(item.createTime)}}</div>
                          <div class="font-12-b9b9b9 mb-8">{{result.content}}</div>
                          <div class="text-left flex flex-wrap">
                            <div v-for="(pic, j) in result.photoList" :key="j" class="mr-10 mb-10">
                              <viewer :images="result.photoList">
                                <img style="width: 90px; height: 90px"  :src="Utils.IMG_PREV + pic.path" fit="cover">
                              </viewer>
                            </div>
                          </div>
                        </div>
                        <div class="hr-dashed" v-if="i < item.resultList.length - 1"></div>
                      </div>
                    </div>
                  </div>
                </transition>
                <div class="bottom">
                  <div class="font-12-30313a" @click="onShow(index)"><div>{{item.active ? '收起' : '展开结果'}}</div><i :class="item.active ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="ml-2"></i></div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
    </el-main>
    <!--新增回访-->
    <el-dialog title="新增回访" :visible.sync="addVisible" width="530px" class="addReturn">
      <div class="p-20">
        <el-form ref="form" :model="add">
          <el-form-item style="margin-bottom: 0;">
            <div class="flex">
              <div class="font-12-30313a">填写回访内容：</div>
              <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入内容" v-model="add.content" maxlength="50" show-word-limit resize="none"></el-input>
            </div>
          </el-form-item>
          <div class="hr-dashed" style="margin: 16px 0;"></div>
          <div class="flex align-center mb-10">
            <img class="mr-5" src="/static/images/jinggao.png" alt="">
            <div class="font-12-30313a">若有问题，可选择处理人进行问题处理！</div>
          </div>
          <el-form-item>
            <div class="flex align-center">
              <div class="font-12-30313a">选择处理人员：</div>
              <div class="flex-1 chooseHandle flex align-center justify-space-between plr-10" @click="chooseHandler">
                <div class="flex-1 w-0 text-left">
                  <div class="font-12-b9b9b9" v-if="projectMemberStr === ''">请在该项目的成员和问题处理人员内选择</div>
                  <div class="font-12-30313a" v-else>{{projectMemberStr}}</div>
                </div>
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <div class="flex">
              <div class="font-12-30313a"><span style="display:inline-block; width: 10px; height: 1px;"></span>添加回访照片：</div>
              <div>
                <el-upload
                  class="text-left"
                  multiple
                  name="file"
                  :httpRequest="httpRequestImg"
                  :action="upload"
                  :show-file-list="false"
                  :before-upload="beforeImgUpload">
                  <div class="addBtn cursor mb-10 button">
                    <img src="/static/images/customer/chubeikehu.png" alt="">
                    <div>上传图片</div>
                  </div>
                </el-upload>
                <div class="flex flex-wrap ">
                  <div class="picItem mr-10 mb-10 relative" v-for="(item, index) in add.pic" :key="index">
                    <el-image :src="Utils.IMG_PREV + item.path" alt="" fit="cover" style="width: 100%; height: 100%;"></el-image>
                    <img src="/static/images/removeImg.png" class="absolute removeIcon" alt="" @click="removePic(index)">
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <div class="btn-30-bd-85-s mr-10" @click="onCloseAdd">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitAdd">确定</div>
      </div>
    </el-dialog>
    <choose-handler ref="chooseHandler" :id="id" :flag="handlerFlag" :handleId="handleId"></choose-handler>
    <to-handle ref="toHandle" :handleId="handleId" :type="handleType"></to-handle>
    <finish-handle ref="finishHandle" :handleId="handleId" :type="handleType"></finish-handle>
  </el-container>
</template>

<script>
import ChooseHandler from './components/ChooseHandler'
import ToHandle from './components/ToHandle'
import FinishHandle from './components/FinishHandle'
import Pagination from '../../components/Pagination'
export default {
  name: 'customerReturn',
  components: {ChooseHandler, ToHandle, FinishHandle, Pagination},
  data () {
    return {
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      id: null,
      parent: null,
      info: {},
      addVisible: false,
      add: {
        content: '',
        pic: [],
        handlerParamList: []
      },
      projectMemberStr: '',
      page: 1,
      limit: 10,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 0,
      total: 0,
      handleList: [],
      handlerFlag: false,
      handleId: null,
      handleType: 1,
      permission: []
    }
  },
  created () {},
  mounted () {
    this.id = this.$route.query.id
    this.parent = this.$route.query.parent
    this.getInfo()
    this.getHandleList()
    this.getPermission()
  },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'customerReturn',
        parentGroup: 'customerReturn'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
        }
      })
    },
    getHandleList () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customerHandle/queryForPage`, {
        customerId: this.id,
        page: this.page,
        limit: this.limit,
        type: 1
      }).then(res => {
        if (res.data.success) {
          this.handleList = []
          res.data.data.list.forEach(i => {
            i.active = false
            this.handleList.push(i)
          })
          this.$refs.chooseHandler.getProjectMember()
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        }
      })
    },
    executorList (list) {
      let arr = []
      list.forEach(i => {
        arr.push(i.name + ' / ' + i.telephone)
      })
      return arr.join('、')
    },
    addReturn () {
      this.addVisible = true
    },
    chooseHandler () {
      this.handlerFlag = false
      this.$refs.chooseHandler.chooseHandlerVisible = true
    },
    onSubmitAdd () {
      if (this.add.content === null || this.add.content === '') {
        this.$message({
          message: '请输入回访内容',
          type: 'warning'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerHandle/save`, {
          customerId: this.id,
          content: this.add.content,
          handlerParamList: this.add.handlerParamList,
          photoParamList: this.add.pic,
          type: 1
        }).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.onCloseAdd()
            this.getHandleList()
            this.$refs.chooseHandler.onReset()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    onCloseAdd () {
      this.addVisible = false
      this.add = {
        handlerParamList: [],
        content: ''
      }
    },
    toChangeHandler (item) {
      this.$refs.chooseHandler.selectedList = this.Utils.deepClone(item.handlerList)
      this.$refs.chooseHandler.projectMemberStr = this.executorList(item.handlerList)
      this.handlerFlag = true
      this.handleId = item.id
      this.$nextTick(() => {
        this.$refs.chooseHandler.chooseHandlerVisible = true
      })
    },
    toHandle (item) {
      this.handleId = item.id
      this.handleType = 1
      this.$refs.toHandle.handleVisible = true
    },
    toReturn (item) {
      this.handleId = item.id
      this.handleType = 2
      this.$refs.finishHandle.returnResultVisible = true
    },
    toDelete (item) {
      this.$confirm('此操作将删除该计划, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerHandle/deleteById`, this.qs.stringify({
          id: item.id
        })).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.getHandleList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    beforeImgUpload () {},
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 4)
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.add.pic.push({path: onloadRes.data.data.path})
        }
      }).catch(() => {
        this.$message.error('上传失败3！')
      })
    },
    removePic (index) {
      this.add.pic.splice(index, 1)
    },
    onShow (index) {
      this.handleList[index].active = !this.handleList[index].active
    },
    onClose () {
      this.$router.go(-1)
    },
    jump (page) {
      this.page = page
      this.getHandleList()
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-main{
    padding: 0;
  }
  .customerInfo{
    width: 100%;
    height: 50px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #30313a;
    text-align: left;
    padding-left:20px;
    position: relative;
  }
  .close{
    width: 50px;
    height: 50px;
    background: #ff5555;
  }
  .customerInfo span{
    color: #b9b9b9;
  }
  .line{
    height: 32px;
    background: #f3f4f7;
    width: 1px;
    margin: 0 20px;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
    margin: 10px 0;
  }
  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e2e2e2;
    margin: 12px 0;
  }
  .content{
    padding: 10px 20px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content .title{
    height: 30px;
    padding-left: 20px;
    border-radius: 4px;
  }
  .addBtn{
    background: #fff;
    width: 85px;
    height: 24px;
    color: #30313a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 4px;
  }
  .returnList{
    overflow-y: auto;
  }
  .returnList /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .returnItem{
    text-align: left;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .returnItem .bottom{
    border-top: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
  }
  .returnItem .bottom > div{
    width: 80px;
    height: 20px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #e2e2e2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .returnItem .center{
    border-top: 1px solid #e2e2e2;
  }
  .returnItem .center .list{
    padding:15px;
  }
  .expand-enter-active {
    transition: max-height 7s;
    overflow: hidden;
    max-height: 7777px;
  }
  .expand-enter {
    max-height: 0;
  }
  .addReturn /deep/ .el-textarea__inner{
    padding-left: 10px;
    padding-right: 10px;
    height: 160px;
  }
  .button{
    border: 1px solid #e2e2e2;
  }
  .picItem{
    width: 70px;
    height: 70px;
  }
  .removeIcon{
    top:5px;
    right: 5px;
    cursor: pointer;
  }
  .chooseHandle{
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    cursor: pointer;
  }
  .w-260{
    width: 260px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/customerReturn.vue